<script setup lang="ts">
import { MMPopupDefault, MMText } from '@mm-frontend/mm-web-ui-kit';
import { useLegalSDK } from '../business/useLegalSDK';
import { ButtonPrimaryNeutral, ButtonSecondaryNeutral, ButtonTertiaryOutlined } from '~/features/ui-kit';
import ButtonPrimaryAccented from '~/features/ui-kit/buttons/ui/ButtonPrimaryAccented.vue';

const { allLegalCustomers, loginAsLegal } = useLegalSDK();

const emit = defineEmits<{ (e: 'close'): void }>();

function selectLegalAccount(legalCustomerId: number) {
  loginAsLegal(legalCustomerId);
  emit('close');
}
</script>

<template>
  <MMPopupDefault class="select-legal-account-popup" @close="$emit('close')">
    <template #header>
      <MMText font="Title M/Semibold">Сменить аккаунт</MMText>
    </template>

    <template #default>
      <div class="select-legal-account">
        <div v-for="legalCustomer in allLegalCustomers" :key="legalCustomer.legalCustomerId">
          <ButtonTertiaryOutlined
            font="Body M/Medium"
            w100 
            class="select-legal-account__button"
            @click="selectLegalAccount(legalCustomer.legalCustomerId)"
          >
            {{ legalCustomer.organizationName }}
          </ButtonTertiaryOutlined>
        </div>
      </div>
    </template>

    <template #footer>
      <ButtonSecondaryNeutral w100 @click="$emit('close')">Отмена</ButtonSecondaryNeutral>
    </template>
  </MMPopupDefault>
</template>

<style scoped lang="stylus">
.select-legal-account-popup
  width 360px

.select-legal-account
  display flex
  flex-direction column
  gap 8px
  padding 24px 0

  &__button
    height auto
    padding-top 12px
    padding-bottom 12px
</style>